<div class="tv-cell">
    <div class="tv-hours-row">
        <label class="tv-hint" [hidden]="editMode">Enter hrs</label>
        <label class="tv-hint tv-hint--done" [hidden]="!editMode">Entered</label>
        <input class="tv-input"
               type="number"
               [disabled]="editMode"
               min="0"
               max="10"
               name="hrs_{{ inputDate }}"
               [ngModel]="enteredData"
               (ngModelChange)="enteredTime($event)" />
    </div>
    <textarea class="tv-comments"
              rows="2"
              [disabled]="editMode"
              placeholder="Task / notes�"
              name="cmt_{{ inputDate }}"
              (ngModelChange)="enteredComment($event)"
              [(ngModel)]="enteredComments"></textarea>
</div>
